import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

import Link from '../channel/Link';
import Icon from '../common/Icon';
import { mayEditRestream } from '../../helpers/permissions';
import { useUser } from '../../hooks/user';

const Channel = ({ channel, episode, onEditRestream }) => {
	const { user } = useUser();

	return <div className="episode-channel text-nowrap">
		<Link channel={channel} />
		{onEditRestream && mayEditRestream(user, episode, channel) ?
			<Button
				className="ms-1"
				onClick={() => onEditRestream(episode, channel)}
				variant="outline-secondary"
			>
				<Icon.SETTINGS />
			</Button>
		: null}
	</div>;
};

Channel.propTypes = {
	channel: PropTypes.shape({
		short_name: PropTypes.string,
		stream_link: PropTypes.string,
		title: PropTypes.string,
	}),
	episode: PropTypes.shape({
	}),
	onEditRestream: PropTypes.func,
};

export default Channel;
